




import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { BreadcrumbsItem } from '@/types/BreadcrumbItem';
import { Location } from '@/modules/backend/Entities/Location';
import { Building } from '@/modules/backend/Entities/Building';
import { Company } from '@/modules/backend/Entities/Company';
import Breadcrumbs from '@/components/breadcrumbs/Breadcrumbs.vue';
import { Account } from '@/modules/backend/Entities/Account';
import { CompaniesModule } from '@/store/dashboard/companies/CompaniesModule';
import { BuildingsModule } from '@/store/dashboard/buildings/BuildingsModule';
import { LocationsModule } from '@/store/dashboard/locations/LocationsModule';
import { AccountsModule } from '@/store/dashboard/accounts/AccountsModule';
import { resolveModule } from '@/store';
import { emptyPlaceholder } from '@/filters/emptyPlaceholder';

@Component({
  components: {
    breadcrumbs: Breadcrumbs,
  }
})
export default class DashboardBreadcrumbs extends Vue {
  private readonly companiesModule: CompaniesModule = resolveModule(CompaniesModule);
  private readonly buildingsModule: BuildingsModule = resolveModule(BuildingsModule);
  private readonly locationsModule: LocationsModule = resolveModule(LocationsModule);
  private readonly accountsModule: AccountsModule = resolveModule(AccountsModule);

  @Prop({ type: Number })
  private readonly companyId!: number;

  @Prop({ type: Number })
  private readonly buildingId!: number;

  @Prop({ type: Number })
  private readonly locationId!: number;

  @Prop({ type: Number })
  private readonly accountId!: number;

  private get isVisible(): boolean {
    return !!(this.company || this.building || this.location || this.account);
  }

  get account(): Account | undefined {
    if (this.accountId) {
      return this.accountsModule.AccountById(this.accountId);
    }

    return undefined;
  }

  get location(): Location | undefined {
    if (this.locationId) {
      return this.locationsModule.LocationById(this.locationId);
    }

    if (this.account) {
      return this.account.getLocation();
    }

    return undefined;
  }

  get building(): Building | undefined {
    if (this.buildingId) {
      return this.buildingsModule.BuildingById(this.buildingId);
    }

    if (this.location) {
      return this.location.getBuilding();
    }

    return undefined;
  }

  get company(): Company | undefined {
    if (this.companyId) {
      return this.companiesModule.CompanyById(this.companyId);
    }

    if (this.building) {
      return this.building.getCompany();
    }

    return undefined;
  }

  get breadcrumbsItems(): BreadcrumbsItem[] {
    let result: BreadcrumbsItem[] = [];

    if (this.account) {
      result = [{
        disabled: false,
        to: this.account.getRouteLocation(),
        text: this.account.getContent() ? `${this.account.getName()}: ${this.account.getContent()}` : this.account.getName()
      }, ...result];
    }

    if (this.location) {
      result = [{
        disabled: false,
        to: this.location.getRouteLocation(),
        text: this.location.getName()
      }, ...result];
    }

    if (this.building) {
      result = [{
        disabled: false,
        to: this.building.getRouteLocation(),
        text: emptyPlaceholder(this.building.getName())
      }, ...result];
    }

    if (this.company) {
      result = [{
        disabled: false,
        to: this.company.getRouteLocation(),
        text: this.company.getName()
      }, ...result];
    }

    return result;
  }
}
